/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSWITCHFREQUENCY = {
    Monthly: '12',
    Quarterly: '4'
} as const;
export type IAPSWITCHFREQUENCY = typeof IAPSWITCHFREQUENCY[keyof typeof IAPSWITCHFREQUENCY];


export function IAPSWITCHFREQUENCYFromJSON(json: any): IAPSWITCHFREQUENCY {
    return IAPSWITCHFREQUENCYFromJSONTyped(json, false);
}

export function IAPSWITCHFREQUENCYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSWITCHFREQUENCY {
    return json as IAPSWITCHFREQUENCY;
}

export function IAPSWITCHFREQUENCYToJSON(value?: IAPSWITCHFREQUENCY | null): any {
    return value as any;
}

